import React, { Component } from 'react'
// import './indiaCovidResponse.scss';

export default class index extends Component {
    render() {
        return (
            <div className="ind-covid-response">
                <div className="icr-content container">
                    <div className="icr-header">
                        <h2>India COVID Response Fund</h2>
                        <div className="icr-header-bar"></div>
                    </div>
                    <p className="icr-desciption">
                        India COVID Response Fund (ICRF) is best described as a giving collective that enables both individuals and organisations to respond together to COVID. In 2020, ICRF raised ₹220Cr+, impacting the lives of 56L+ people in India. We re-launched ICRF in April 2021, in response to the grave second wave of COVID to support gaps in healthcare and other critical needs.
                    </p>
                    <div className="icr-box-wrapper">
                        <div className="icr-content-box">
                            <strong>15L+</strong>
                            <p>Donors supporting COVID missions across healthcare, humanitarian and cash relief</p>
                        </div>
                        <div className="icr-content-box">
                            <strong>300+</strong>
                            <p>NGOs and implementation partners working to create widespread impact</p>
                        </div>
                        <div className="icr-content-box">
                            <strong>65L+</strong>
                            <p>Indians supported across 22 states with funds for our COVID relief work</p>
                        </div>
                    </div>
                    <div className="icr-btn-wrapper">
                        <a href="https://cfstatic.giveindia.org/a1a4829a-2a74-4b0a-96b7-7c5d9b46a24f.pdf"
                            target="_blank"
                            onClick={() => {
                                if (window.eventDispatcher) {
                                    window.eventDispatcher.dispatchEventSync(
                                        'icrf-2020-report-card',
                                        {},
                                        { amplitude: true }
                                    );
                                }
                            }}
                        >
                            <button className="btn btn-lg btn-secondary">See 2020 COVID report</button>
                        </a>
                        <a href="https://e.issuu.com/embed.html?d=icrf-2_final_report_issu&hideIssuuLogo=true&hideShareButton=true&u=giveindia"
                            target="_blank"
                            onClick={() => {
                                if (window.eventDispatcher) {
                                    window.eventDispatcher.dispatchEventSync(
                                        'icrf-2021-report-card',
                                        {},
                                        { amplitude: true }
                                    );
                                }
                            }}
                        ><button className="btn btn-lg btn-secondary">See 2021 COVID report</button></a>
                        <a href="https://covid.giveindia.org/?utm_campaign=ICRF2&utm_medium=ICRFBlock&utm_term=&utm_content="
                            target="_blank"
                            onClick={() => {
                                if (window.eventDispatcher) {
                                    window.eventDispatcher.dispatchEventSync(
                                        'icrf-donate-now',
                                        {},
                                        { amplitude: true }
                                    );
                                }
                            }}
                        ><button className="btn btn-lg btn-primary">Donate now</button></a>
                    </div>
                </div>
            </div>
        )
    }
}

